import React, { FC, useEffect, useRef } from 'react';

type LTIHiddenFormProps = {
  exerciseId: string;
  isDuplicate: boolean;
  action: string;
  target: string;
  fields: { [key: string]: any };
};

export const LTIHiddenForm: FC<LTIHiddenFormProps> = ({ isDuplicate, action, target, fields }) => {
  const formRef = useRef<HTMLFormElement>(null);
  useEffect(() => {
    if (!formRef.current) return;
    formRef.current.submit();
  }, [formRef, fields, isDuplicate]);

  return (
    <form
      ref={formRef}
      action={action}
      name="frmLaunch"
      id={`auth_form_${target}`}
      method="post"
      encType="application/x-www-form-urlencoded"
      target={target}
    >
      {Object.entries(fields).map(([key, value]) => (
        <input key={key} type="hidden" name={key} defaultValue={value} />
      ))}
    </form>
  );
};
